import React from 'react'
import { Icon, Image } from 'semantic-ui-react'
import { createAPIClient, createAWSClient } from '../../../../../services/api'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload, faSpinner, faPlus } from '@fortawesome/free-solid-svg-icons'
class FileUpload extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false
    }
    this.handleClick = this.handleClick.bind(this)
    this.onFileChange = this.onFileChange.bind(this)
    this.uploadFile = this.uploadFile.bind(this)
  }
  handleClick () {
    if (this.state.loading) return
    this.refs.fileUploader.click()
  }
  onFileChange (event) {
    event.stopPropagation()
    event.preventDefault()
    var file = event.target.files[0]
    if (!file) {
      return
    }
    this.uploadFile(file)
  }
  uploadFile (file) {
    // send a post request and get upload url
    const api = createAPIClient()
    const extension = file.name.split('.')[1]
    const fileName = file.name.split('.')[0].replace(/ /g, '') + '_' + (new Date()).getTime() + '.' + extension
    const _self = this
    this.setState({loading: true})
    api.get(`/api/private/upload/url-files?filename=${fileName}&type=incident-attachment`)
      .then(result => {
        const url = result.data.response
        const awsClient = createAWSClient()
        awsClient.put(url, file, {})
          .then(() => {
            var saveUrl = url.split('?')[0]
            var attachments = []
            attachments = attachments.concat(this.props.issue.attachments)
            attachments.push({url: saveUrl, key: saveUrl})
            const updateDetails = {attachments}
            _self.props.updateIssueAction(_self.props.issue.id, updateDetails, function (result) {
              _self.setState({loading: false})
            })
          })
      })
      .catch(error => {
        console.log(error)
      })
  }
  render () {
    return (
      <React.Fragment>
        <a href='#'>
          <FontAwesomeIcon
            style={{width: '20px', height: '20px', verticalAlign: 'middle'}}
            icon={this.state.loading ? faSpinner : faPlus}
            color={'black'} spin={this.state.loading}
            onClick={this.handleClick} />
        </a>
        <input
          type='file'
          id='file'
          ref='fileUploader'
          style={{display: 'none'}}
          onChange={this.onFileChange.bind(this)}
        />
      </React.Fragment>
    )
  }
}

export default FileUpload




// WEBPACK FOOTER //
// ./src/pages/issues/overview/components/instance-file-upload/index.js